export default function awaitUntil(conditionBlock) {
  return new Promise((resolve) => {
    const checkCondition = () => {
      if (conditionBlock()) {
        resolve()
      } else {
        setTimeout(checkCondition, 50)
      }
    }

    checkCondition()
  })
}
